var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    rx: 80,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 159,
    rx: 79.5,
    stroke: "#364957",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 72.2199L77.5384 77.5531L90 65.5532M44.1133 73.5531L72.8984 92.8195C75.4644 94.5303 76.7476 95.3855 78.1344 95.7179C79.3596 96.0115 80.6372 96.0115 81.8628 95.7179C83.2496 95.3855 84.5328 94.5303 87.0988 92.8195L115.884 73.5531M73.1924 49.8284L49.9926 64.3983C47.8048 65.7722 46.711 66.4591 45.9176 67.3878C45.2154 68.2097 44.687 69.1654 44.3644 70.1972C44 71.363 44 72.6546 44 75.2379V100.753C44 105.234 44 107.474 44.872 109.185C45.6389 110.69 46.8628 111.914 48.3681 112.681C50.0794 113.553 52.3196 113.553 56.8 113.553H103.2C107.68 113.553 109.921 113.553 111.632 112.681C113.137 111.914 114.361 110.69 115.128 109.185C116 107.474 116 105.234 116 100.753V75.2379C116 72.6546 116 71.363 115.636 70.1972C115.313 69.1654 114.785 68.2097 114.082 67.3878C113.289 66.4591 112.195 65.7722 110.008 64.3983L86.8076 49.8284C84.3384 48.2779 83.104 47.5026 81.7796 47.2004C80.608 46.9332 79.392 46.9332 78.2204 47.2004C76.896 47.5026 75.6616 48.2779 73.1924 49.8284Z",
    stroke: "#6B7280",
    strokeWidth: 5.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailed);
export default __webpack_public_path__ + "static/media/Mailed.f4c5f45a8d76592a50b72197ef6a3f40.svg";
export { ForwardRef as ReactComponent };